import { combineReducers } from 'redux';
import { enableMapSet } from 'immer';

import { withCompareReducer } from '@exp/redux/compare';
import { withFollowReducer } from '@exp/redux/following';
import { withPreviewReducer } from '@exp/redux/previewMode';
import { punchoutReducer } from '@exp/redux/punchout';
import { withTestReducer } from '@exp/redux/TestSlice';

import brandHeaderReducer from '../brandHeader/brandHeaderReducer';
import campaignAssetReducer from '../campaign/campaignAsset/campaignAssetReducer';
import cartReducer from '../cart/cartReducer';
import guidelinesReducer from '../store/components/guidelines/guidelinesReducer';
import noAccessErrorReducer from '../storeError/noAccessError/noAccessErrorReducer';
import orderHistoryReducer from '../orderHistory/orderHistorySlice';
import productCategoryReducer from '../productCategory/productCategoryReducer';
import productDetailsReducer from '../product/productDetailsReducer';
import productUngatedReducer from '../productUngated/productUngatedReducer';
import promoBannerReducer from '../promoBanner/promoBannerReducer';
import singleCheckoutReducer from '../singleCheckout/singleCheckoutSlice';
import storeInformationReducer from '../store/storeInformationReducer';
import topProductsReducer from '../love/topProductsReducer';
import updatePaymentReducer from '../updatePayment/updatePaymentReducer';

// allows storing Maps and Sets in redux
// related to redux toolkit
enableMapSet();

const rootReducer = combineReducers({
  ...withCompareReducer(),
  ...withFollowReducer(),
  ...withPreviewReducer(),
  ...withTestReducer(),
  brandContent: noAccessErrorReducer,
  brandInformation: brandHeaderReducer,
  campaignAsset: campaignAssetReducer,
  cart: cartReducer,
  guidelines: guidelinesReducer,
  orderHistory: orderHistoryReducer,
  productCategories: productCategoryReducer,
  productDetails: productDetailsReducer,
  productPreview: productUngatedReducer,
  promoStores: promoBannerReducer,
  punchoutInformation: punchoutReducer,
  singleCheckout: singleCheckoutReducer,
  storeInformation: storeInformationReducer,
  topProducts: topProductsReducer,
  updatePayment: updatePaymentReducer,
});

export default rootReducer;
